import React from 'react';

type Props = {
  baseUrl?: string;
  imagePath: string;
  alt: string;
  className?: string;
};

function getSrcSet(
  imagePath: string,
  extension: 'webp' | 'png',
  baseUrl: string
) {
  return `${baseUrl}${imagePath}.${extension} 1x, ${baseUrl}${imagePath}@2x.${extension} 2x`;
}

export function Picture({
  baseUrl = 'https://d12xoj7p9moygp.cloudfront.net/images',
  imagePath,
  alt,
  className,
}: Props) {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={getSrcSet(imagePath, 'webp', baseUrl)}
      />
      <img
        className={className}
        loading="lazy"
        alt={alt}
        srcSet={getSrcSet(imagePath, 'png', baseUrl)}
      />
    </picture>
  );
}
